import { NationalIdState, NationalIdType } from "../types";

const state: NationalIdState = {
  nationalIdType: NationalIdType.NEW,
  nationalIdFrontBlob: undefined,
  nationalIdBackBlob: undefined,
};

export default state;
